<script setup>
  defineProps({
    item: Object
  })
</script>

<template>
  <div
    :id="item.year"
    class="element-timeline-item swiper-slide"
  >
    <div
      class="timeline-item-items flex flex-col"
      v-html="item.items"
    />
  </div>
</template>

<style lang="scss" scoped>

</style>
